import React, { useState } from 'react';
import { SelectedGarmentContextType } from './types/SelectedGarmentContentType';

export const SelectedGarmentContext =
  React.createContext<SelectedGarmentContextType | null>(null);

type SelectedGarmentProviderProps = {
  children: React.ReactNode;
};

const SelectedGarmentProvider: React.FC<SelectedGarmentProviderProps> = ({
  children,
}) => {
  const [selectedGarmentId, setSelectedGarmentId] = useState(0);
  const saveSelectedGarmentId = (id: number) => {
    setSelectedGarmentId(id);
  };
  return (
    <SelectedGarmentContext.Provider
      value={{ selectedGarmentId, saveSelectedGarmentId }}
    >
      {children}
    </SelectedGarmentContext.Provider>
  );
};

export default SelectedGarmentProvider;
